import React, { useEffect, useState } from "react";
import { Trash2, Plus, Hammer, SaveAll } from "lucide-react";
import uploadmutiplefile from "../../common/Uploadmultplefile";
import toast from "react-hot-toast";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Autocomplete, TextField } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import Extract from "./Extract";

const Vehicleservicepartdetails = ({
  workOrderDetail,
  partservice,
  setPartService,
  vehicleServicePartDetails,
  setVehicleServicePartDetails,
  handleImageOpen,
  setActiveTab,
  creationType,
  getVehicleServicePartDetails,
  setCreationType,
  setBulkPartService,
  bulkPartservice,
}) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  const [partList, setPartList] = useState([]);
  const [searchVelues, setSearchValues] = useState("");
  const [listLoading, setListLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const addRow = () => {
    setPartService([
      ...partservice,
      {
        partName: null,
        partNumber: null,
        actionOnPart: null,
        quantity: null,
        unitPrice: null,
        laborCost: null,
        totalCost: null,
        totalTax: null,
        warrantyExpiryDate: null,
        attachments: [],
        discountAmount: null,
        discountPercentage: null,
        cgstPercentage: null,
        sgstPercentage: null,
      },
    ]);
  };

  const parseImages = (value) => {
    try {
      if (!value) return [];

      // If already array → return as is
      if (Array.isArray(value)) return value;

      // If it's a string → parse it
      const parsed = typeof value === "string" ? JSON.parse(value) : value;

      // If parsed is array → return
      if (Array.isArray(parsed)) return parsed;

      // If it's a single object → wrap in array
      if (typeof parsed === "object") return [parsed];

      return [];
    } catch (e) {
      return [];
    }
  };

  function ccyFormat(num) {
    return `${Number(num || 0).toFixed(2)}`;
  }

  const removeRow = (index) => {
    const updated = partservice.filter((_, i) => i !== index);
    setPartService(updated);
  };

  const handleChange = (index, field, value) => {
    const updated = [...partservice];
    const item = { ...updated[index], [field]: value };

    const parseNum = (v) => Number(v || 0);
    const isEmptyValue = (v) => v === "" || v === null || v === undefined;

    const getLineAmount = (row) =>
      parseNum(row.unitPrice) * parseNum(row.quantity);
    const getTaxableBase = (row) => {
      const lineAmount = getLineAmount(row);
      const discountAmount = parseNum(row.discountAmount);
      const laborCost = parseNum(row.laborCost);
      return lineAmount - discountAmount + laborCost;
    };
    const computeTaxAmount = (row) => {
      const percentage = parseNum(row.totalTaxPercentage || row.totalTax || 0);
      const base = getTaxableBase(row);
      return +((base * percentage) / 100);
    };

    if (field === "discountAmount") {
      const lineAmount = getLineAmount(item);
      const discountAmount = parseNum(value);
      item.discountPercentage = lineAmount
        ? Number(((discountAmount / lineAmount) * 100).toFixed(2))
        : "";
    }

    if (field === "discountPercentage") {
      const lineAmount = getLineAmount(item);
      const discountPercentage = parseNum(value);
      item.discountAmount = lineAmount
        ? Number(((discountPercentage / 100) * lineAmount).toFixed(2))
        : "";
    }

    if (field === "quantity" || field === "unitPrice") {
      const lineAmount = getLineAmount(item);
      if (item.discountPercentage) {
        item.discountAmount = lineAmount
          ? Number(
              ((parseNum(item.discountPercentage) / 100) * lineAmount).toFixed(
                2,
              ),
            )
          : "";
      } else if (item.discountAmount) {
        item.discountPercentage = lineAmount
          ? Number(
              ((parseNum(item.discountAmount) / lineAmount) * 100).toFixed(2),
            )
          : "";
      }
    }

    if (field === "totalTaxPercentage" || field === "totalTax") {
      const currentValue = item.totalTaxPercentage || item.totalTax;
      const percentage = isEmptyValue(currentValue)
        ? ""
        : parseNum(currentValue);
      item.totalTaxPercentage = percentage;
      item.totalTax = percentage;
    }

    if (field === "totalTaxAmount") {
      const base = getTaxableBase(item);
      const amountValue = item.totalTaxAmount;
      const amount = isEmptyValue(amountValue) ? "" : parseNum(amountValue);
      const percentage =
        base > 0 && amount !== "" ? +((amount / base) * 100) : "";
      item.totalTaxPercentage =
        percentage === "" ? "" : Number(percentage.toFixed(2));
      item.totalTax = percentage === "" ? "" : Number(percentage.toFixed(2));
      item.totalTaxAmount =
        amount === ""
          ? ""
          : Number(amount.toFixed ? amount.toFixed(2) : amount);
    }

    const taxAmount = computeTaxAmount(item);
    item.totalTaxAmount = isFinite(taxAmount)
      ? Number(taxAmount.toFixed(2))
      : 0;
    item.totalCost = Number(
      (getTaxableBase(item) + item.totalTaxAmount).toFixed(2),
    );

    updated[index] = item;
    setPartService(updated);
  };

  const handleFileChange = async (index, files) => {
    toast.loading("Image Upload Processing... Please wait", {
          id: "upload", // same ID to update later
          position: "bottom-center",
        });
    const res = await uploadmutiplefile(files, "vehicles", "vehicle");
        toast.dismiss("upload")
    const uploaded = res?.uploaded || [];

    setPartService((prev) => {
      const updated = [...prev];

      updated[index].attachements = [
        ...(updated[index].attachements || []),
        ...uploaded,
      ];

      return updated;
    });
  };

  const getPartDetails = async () => {
    if (!token) {
      return toast.error("Session Expired Close all the tab and signin again");
    }
    try {
      const response = await fetch(
        `${apiUrl}/api/advancesearch/search?key=vehiclePartCatalogs&queryStr=${partservice[0]?.partName}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setPartList(data?.dataValues);
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  const getVehiclePartCatalogs = async () => {
    if (!token) {
      return toast.error("Session Expired Close all the tab and signin again");
    }
    try {
      const response = await fetch(`${apiUrl}/api/vehiclepartcatalogs`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setPartList(data?.entities?.rows);
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  useEffect(() => {
    if (partservice?.parName?.length > 4) {
      getPartDetails();
    }
  }, [partservice?.parName]);

  useEffect(() => {
    getVehiclePartCatalogs();
  }, []);

  const validateStep1 = () => {
    let errors = {};

    if (!partservice[0].partName) errors.partName = "Part Name is required";
    if (!partservice[0].partNumber)
      errors.partNumber = "Part Number is required";
    if (!partservice[0].attachments)
      errors.attachments = "Attachments is required";
    if (!partservice[0].actionOnPart)
      errors.actionOnPart = "Action On Part is required";
    // if (!partservice[0].laborCost) errors.laborCost = "Labor Cost is required";
    if (!partservice[0].unitPrice) errors.unitPrice = "Unit Price is required";
    if (!partservice[0].quantity) errors.quantity = "Quantity is required";
    // if (!partservice[0].warrantyExpiryDate)
    //   errors.warrantyExpiryDate = "Warranty Date is required";

    return errors;
  };

  const saveRow = async () => {
    const validationErrors = validateStep1();

    console.log("validationErrors", validationErrors);

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      toast.error("Please fill all required fields");
      return;
    }

    setErrors({});

    let payload;

    // if (creationType?.type === "new") {
    //   payload = {
    //     taskDescription: tasks[0].description,
    //     laborCost: Number(tasks[0].laborCost),
    //     totalCost: Number(tasks[0].cost),
    //     panelDetails: tasks[0].panelDetails,
    //     attachments: JSON.stringify(tasks[0].attachements),
    //     logId: workOrderDetail?.id,
    //   };
    // } else {
    if (creationType?.type === "new") {
      payload = {
        partName: partservice[0]?.partName,
        partNumber: partservice[0]?.partNumber,
        actionOnPart: partservice[0]?.actionOnPart,
        quantity: partservice[0]?.quantity,
        unitPrice: Number(partservice[0]?.unitPrice),
        warrantyExpiryDate: partservice[0]?.warrantyExpiryDate,
        totalCost: Number(partservice[0]?.totalCost || 0),
        attachments: JSON.stringify(partservice[0]?.attachements),
        laborCost: partservice[0]?.laborCost,
        logId: workOrderDetail?.id,
        sgstPercentage: partservice[0]?.sgstPercentage || 0,
        cgstPercentage: partservice[0]?.cgstPercentage || 0,
        totalTaxPercentage: partservice[0]?.totalTaxPercentage || 0,
        totalTax: partservice[0]?.totalTaxAmount,
        discountAmount: Number(partservice[0]?.discountAmount || 0),
        discountPercentage: Number(partservice[0]?.discountPercentage || 0),
      };
    } else {
      payload = {
        partName: partservice[0]?.partName,
        partNumber: partservice[0]?.partNumber,
        actionOnPart: partservice[0]?.actionOnPart,
        quantity: partservice[0]?.quantity,
        unitPrice: Number(partservice[0]?.unitPrice),
        warrantyExpiryDate: partservice[0]?.warrantyExpiryDate,
        totalCost: Number(partservice[0]?.totalCost || 0),
        attachments: JSON.stringify(partservice[0]?.attachements),
        laborCost: partservice[0]?.laborCost,
        logId: workOrderDetail?.id,
        id: creationType?.id,
        sgstPercentage: partservice[0]?.sgstPercentage || 0,
        cgstPercentage: partservice[0]?.cgstPercentage || 0,
        totalTaxPercentage:
          partservice[0]?.totalTaxPercentage || partservice[0]?.totalTax,
        totalTax: partservice[0]?.totalTaxAmount,
        discountAmount: Number(partservice[0]?.discountAmount || 0),
        discountPercentage: Number(partservice[0]?.discountPercentage || 0),
      };
    }
    // }

    console.log("payload", payload);
    // return;

    toast.loading("Part details adding... Please wait", {
              id: "upload", // same ID to update later
              position: "top-center",
            });

    try {
      const res = await fetch(`${apiUrl}/api/vehicleserviceparts`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data?.statusCode === "0100") {
        toast.dismiss("upload")
        toast.success("Vehicle Service Part Added Successfully 🎉");
        setPartService([
          {
            partName: "",
            partNumber: "",
            actionOnPart: "",
            quantity: "",
            unitPrice: "",
            laborCost: "",
            totalCost: "",
            totalTax: "",
            warrantyExpiryDate: "",
            attachments: [],
            discountAmount: "",
            discountPercentage: "",
            cgstPercentage: "",
            sgstPercentage: "",
          },
        ]);
        setCreationType({
          type: "new",
          id: null,
        });
        // setActiveTab("summary");
        await getVehiclePartCatalogs();
        await getVehicleServicePartDetails(workOrderDetail?.id);
      }
    } catch (err) {
      toast.error("Something went wrong");
    }
  };

  const handlesavePart = async () => {
    let payload;

    payload = {
      name: partservice[0]?.partName,
    };

    try {
      const res = await fetch(`${apiUrl}/api/vehiclepartcatalogs`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data?.statusCode === "0100") {
        toast.success("New Part Added Successfully 🎉");
        // setActiveTab("summary");
        await getVehiclePartCatalogs();
      }
    } catch (err) {
      toast.error("Something went wrong");
    }
  };

  // useEffect(() => {
  //   // if (partservice?.parName && partservice?.partNumber) {
  //   // handlesavePart()
  //   // }
  // }, []);

  const getFileType = (url = "") => {
    const ext = url.split(".").pop().toLowerCase();

    if (["jpg", "jpeg", "png", "gif", "webp"].includes(ext)) return "image";
    if (["mp4", "webm", "ogg"].includes(ext)) return "video";
    if (["pdf"].includes(ext)) return "pdf";
    if (["doc", "docx", "xls", "xlsx", "ppt", "pptx"].includes(ext))
      return "doc";

    return "other";
  };

  useEffect(() => {
    if (!partservice?.length) return;

    setPartService((prev) => {
      const updated = [...prev];
      const current = { ...updated[0] };

      const cgst = Number(current.cgstPercentage || 0);
      const sgst = Number(current.sgstPercentage || 0);
      const totalTaxPercentage = cgst + sgst;
      current.totalTaxPercentage = totalTaxPercentage;
      current.totalTax = totalTaxPercentage;

      const lineAmount =
        Number(current.unitPrice || 0) * Number(current.quantity || 0);
      const discountAmount = Number(current.discountAmount || 0);
      const laborCost = Number(current.laborCost || 0);
      const taxableBase = lineAmount - discountAmount + laborCost;
      const totalTaxAmount = isFinite(taxableBase)
        ? (taxableBase * totalTaxPercentage) / 100
        : 0;
      current.totalTaxAmount = Number(totalTaxAmount.toFixed(2));
      current.totalCost = Number((taxableBase + totalTaxAmount).toFixed(2));

      updated[0] = current;
      return updated;
    });
  }, [partservice[0]?.sgstPercentage, partservice[0]?.cgstPercentage]);

  // useEffect(() => {
  //   if (
  //     partservice[0]?.unitPrice &&
  //     partservice[0]?.quantity &&
  //     partservice[0]?.laborCost
  //   ) {

  //   }
  // }, [
  //   partservice[0]?.quantity,
  //   partservice[0]?.unitPrice,
  //   partservice[0]?.laborCost,
  // ]);

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <div className="flex gap-4">
          <h2 className="text-lg font-bold text-slate-800 flex items-center gap-2">
            <Hammer className="text-blue-600 w-5 h-5" />
            Part Service
          </h2>
          <div class="relative inline-block group">
            <button class="relative px-6 py-3 text-sm font-semibold text-white bg-indigo-600/90 rounded-xl hover:bg-indigo-700/90 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-900 transition-all duration-300 overflow-hidden">
              <div class="absolute inset-0 bg-gradient-to-r from-purple-500/20 to-pink-500/20 blur-xl group-hover:opacity-75 transition-opacity"></div>

              <span class="relative flex items-center gap-2">
                <svg
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  fill="none"
                  class="w-4 h-4"
                >
                  <path
                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    stroke-width="2"
                    stroke-linejoin="round"
                    stroke-linecap="round"
                  ></path>
                </svg>
              </span>
            </button>

            <div class="absolute invisible opacity-0 group-hover:visible group-hover:opacity-100 bottom-full left-1/2 -translate-x-1/2 mb-3 w-72 transition-all duration-300 ease-out transform group-hover:translate-y-0 translate-y-2">
              <div class="relative p-4 bg-gradient-to-br from-gray-900/95 to-gray-800/95 backdrop-blur-md rounded-2xl border border-white/10 shadow-[0_0_30px_rgba(79,70,229,0.15)]">
                <div class="flex items-center gap-3 mb-2">
                  <div class="flex items-center justify-center w-8 h-8 rounded-full bg-indigo-500/20">
                    <svg
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      class="w-4 h-4 text-indigo-400"
                    >
                      <path
                        clip-rule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                        fill-rule="evenodd"
                      ></path>
                    </svg>
                  </div>
                  <h3 class="text-sm font-semibold text-white">
                    Important Information
                  </h3>
                </div>

                <div class="space-y-2">
                  <p class="text-sm text-gray-300">
                    If Part is not in the dropdown. Please type part name and
                    click tick icon to create new part.
                  </p>
                </div>

                <div class="absolute inset-0 rounded-2xl bg-gradient-to-r from-indigo-500/10 to-purple-500/10 blur-xl opacity-50"></div>

                <div class="absolute -bottom-1.5 left-1/2 -translate-x-1/2 w-3 h-3 bg-gradient-to-br from-gray-900/95 to-gray-800/95 rotate-45 border-r border-b border-white/10"></div>
              </div>
            </div>
          </div>
        </div>

        <button
          type="button"
          onClick={addRow}
          disabled={partservice.length >= 1}
          className="text-sm bg-blue-600 text-white px-3 py-1.5 rounded-lg hover:bg-blue-700 transition flex items-center gap-1"
        >
          <Plus size={16} />
          Add Part
        </button>
      </div>

      <div className="space-y-3">
        {partservice.map((task, index) => (
          <div
            key={index}
            className="grid grid-cols-12 gap-3 items-center bg-gray-200 p-3 rounded-lg border border-gray-100"
          >
            <div className="col-span-3 flex">
              <Autocomplete
                freeSolo
                options={partList || []}
                getOptionLabel={(option) => {
                  if (typeof option === "string") return option;
                  return option.name || "";
                }}
                value={partservice[0].partName || null}
                onChange={(_, newValue) => {
                  handleChange(index, "partName", newValue);
                }}
                fullWidth
                inputValue={
                  typeof partservice[0].partName === "string"
                    ? partservice[0].partName
                    : partservice[0].partName?.label || ""
                }
                onInputChange={(_, newInputValue) => {
                  // store typed value also
                  handleChange(index, "partName", newInputValue);

                  // trigger API when typing
                  if (newInputValue.length > 2) {
                    setSearchValues(newInputValue);
                    getPartDetails();
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    placeholder="Search Part Name"
                  />
                )}
              />

              {partservice[0]?.partName &&
                partList.filter(
                  (part) => part?.name !== partservice[0]?.partName,
                ) && (
                  <button
                    onClick={() => {
                      handlesavePart();
                    }}
                    title="Add new part"
                    className="mt-2 text-sm"
                  >
                    <CheckIcon className="text-green-500" />
                  </button>
                )}
            </div>
            <div className="col-span-2">
              <input
                type="text"
                placeholder="HSN / Part Number"
                className="w-full border rounded-md p-2 text-sm"
                value={task.partNumber}
                onChange={(e) =>
                  handleChange(index, "partNumber", e.target.value)
                }
              />
            </div>

            <div className="col-span-2">
              <select
                value={task.actionOnPart}
                onChange={(e) =>
                  handleChange(index, "actionOnPart", e.target.value)
                }
                className={`border border-gray-300 rounded-md px-3 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm transition h-11 w-full border rounded-md p-2 w-full`}
              >
                <option value="">Action On Part type</option>
                <option value="repair">Repair</option>
                <option value="replacement">Replacement</option>
                <option value="inspect">Inspect</option>
              </select>
            </div>

            <div className="col-span-1">
              <input
                type="number"
                placeholder="Quantity"
                className="w-full border rounded-md p-2 text-sm"
                value={task.quantity}
                onChange={(e) =>
                  handleChange(index, "quantity", e.target.value)
                }
              />
            </div>
            <div className="col-span-1">
              <input
                type="number"
                placeholder="Unit Price"
                className="w-full border rounded-md p-2 text-sm"
                value={task.unitPrice}
                onChange={(e) =>
                  handleChange(index, "unitPrice", e.target.value)
                }
              />
            </div>

            <div className="col-span-1">
              <input
                type="number"
                placeholder="Labor Cost"
                className="w-full border rounded-md p-2 text-sm"
                value={task.laborCost}
                onChange={(e) =>
                  handleChange(index, "laborCost", e.target.value)
                }
              />
            </div>

            <div className="col-span-2">
              <input
                type="number"
                placeholder="Discount Amount"
                className="w-full border rounded-md p-2 text-sm"
                value={task.discountAmount}
                onChange={(e) =>
                  handleChange(index, "discountAmount", e.target.value)
                }
              />
            </div>

            <div className="col-span-2">
              <input
                type="number"
                placeholder="Discount Percentage"
                className="w-full border rounded-md p-2 text-sm"
                value={task.discountPercentage}
                onChange={(e) =>
                  handleChange(index, "discountPercentage", e.target.value)
                }
              />
            </div>

            <div className="col-span-2">
              {/* <label className="block text-sm font-medium text-gray-700 mb-1">
                Warranty Expiry Date
              </label> */}

              <input
                type="date"
                className="w-full border rounded-md p-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={task.warrantyExpiryDate}
                onChange={(e) =>
                  handleChange(index, "warrantyExpiryDate", e.target.value)
                }
              />
            </div>

            <div className="col-span-2">
              <input
                type="number"
                placeholder="Total Amount"
                className="w-full border rounded-md p-2 text-sm"
                value={task.totalCost}
                disabled
              />
            </div>

            <div className="col-span-12">
              <div className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm">
                <div className="flex items-center justify-between mb-4">
                  <div>
                    <h3 className="text-sm font-semibold text-gray-800">
                      Tax Details
                    </h3>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                  {/* CGST */}
                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      CGST (%)
                    </label>
                    <div className="relative">
                      <input
                        type="number"
                        placeholder="0"
                        value={task.cgstPercentage}
                        onChange={(e) =>
                          handleChange(index, "cgstPercentage", e.target.value)
                        }
                        className="w-full h-11 border border-gray-300 rounded-lg pl-3 pr-8 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      />
                      <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 text-sm">
                        %
                      </span>
                    </div>
                  </div>

                  {/* SGST */}
                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      SGST (%)
                    </label>
                    <div className="relative">
                      <input
                        type="number"
                        placeholder="0"
                        value={task.sgstPercentage}
                        onChange={(e) =>
                          handleChange(index, "sgstPercentage", e.target.value)
                        }
                        className="w-full h-11 border border-gray-300 rounded-lg pl-3 pr-8 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      />
                      <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 text-sm">
                        %
                      </span>
                    </div>
                  </div>

                  {/* Total Tax */}
                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      Total Tax (%)
                    </label>
                    <div className="relative">
                      <input
                        type="number"
                        placeholder="0"
                        value={task.totalTaxPercentage ?? ""}
                        onChange={(e) =>
                          handleChange(
                            index,
                            "totalTaxPercentage",
                            e.target.value,
                          )
                        }
                        className="w-full h-11 border border-gray-300 rounded-lg pl-3 pr-8 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      />
                      <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 text-sm">
                        %
                      </span>
                    </div>
                  </div>

                  {/* Tax Amount */}
                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      Tax Amount (₹)
                    </label>
                    <div className="relative">
                      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">
                        ₹
                      </span>
                      <input
                        type="number"
                        value={task.totalTaxAmount ?? ""}
                        onChange={(e) =>
                          handleChange(index, "totalTaxAmount", e.target.value)
                        }
                        className="w-full h-11 border border-gray-300 rounded-lg pl-8 pr-3 text-sm bg-green-50 font-medium"
                      />
                    </div>
                  </div>
                </div>

                {/* Summary */}
                <div className="mt-4 flex justify-end">
                  <div className="bg-gray-50 border rounded-lg px-4 py-2">
                    <span className="text-xs text-gray-500">GST Rate</span>
                    <div className="text-lg font-semibold text-blue-600">
                      {task.totalTaxPercentage || 0}%
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-span-2">
              {/* <label className="block text-xs font-medium text-gray-600 mb-1">
                Attachments
              </label> */}

              <div className="border-2 border-dashed border-gray-300 rounded-lg p-1 text-center hover:border-blue-500 transition">
                <input
                  type="file"
                  multiple
                  // accept="image/*"
                  className="hidden"
                  id={`file-${index}`}
                  onChange={(e) => handleFileChange(index, e.target.files)}
                />

                <label
                  htmlFor={`file-${index}`}
                  className="cursor-pointer text-sm text-blue-600"
                >
                  Click to upload Attachments
                </label>

                {/* <p className="text-xs text-gray-400 mt-1">PNG, JPG up to 5MB</p> */}
              </div>
              <div className="flex gap-2 mt-2 flex-wrap">
                {task.attachements?.map((file, i) => (
                  <div key={i} className="relative">
                    <img
                      src={file.url || file?.path || file?.Location || file}
                      alt="preview"
                      onClick={() => {
                        handleImageOpen(
                          file.url || file?.path || file?.Location || file,
                        );
                      }}
                      className="w-4 h-4 object-cover rounded-md border"
                    />

                    {/* <button
                      type="button"
                      onClick={() => removeImage(index, i)}
                      className="absolute -top-2 -right-2 bg-white border rounded-full text-red-500 px-1 text-xs"
                    >
                      ✕
                    </button> */}
                  </div>
                ))}
              </div>
            </div>

            <div className="col-span-1 text-center">
              <div className="flex gap-4">
                <button
                  type="button"
                  title="Delete"
                  onClick={() => removeRow(index)}
                  className="text-red-500 hover:text-red-700"
                >
                  <Trash2 size={24} />
                </button>
                <button
                  type="button"
                  title="Save"
                  onClick={() => saveRow(index)}
                  className="text-green-500 hover:text-green-700"
                >
                  <SaveAll size={24} />
                </button>
              </div>
            </div>
          </div>
        ))}

        {/* <br />

        <h1 className="text-center">OR</h1>

        <Extract
          getVehicleServicePartDetails={getVehicleServicePartDetails}
          setBulkPartService={setBulkPartService}
          bulkPartservice={bulkPartservice}
          workOrderDetail={workOrderDetail}
        /> */}
      </div>

      <div className="col-span-12 md:col-span-12 bg-white shadow-lg rounded-2xl p-6 h-full mt-4">
        <h2 className="text-xl font-semibold text-gray-800 mb-2">
          Service Part Items
        </h2>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 700, borderRadius: 10 }}>
            <TableHead>
              <TableRow>
                <TableCell>Part Name</TableCell>
                <TableCell>Part Number</TableCell>
                <TableCell>Action on Part</TableCell>
                <TableCell>Quantity</TableCell>
                <TableCell>Unit Price</TableCell>                
                <TableCell align="right">Labor Cost</TableCell>
                <TableCell align="right">Discount Amount</TableCell>
                <TableCell align="right">Discount Percentage</TableCell>
                <TableCell align="right">CGST Percentage</TableCell>
                <TableCell align="right">SGST Percentage</TableCell>
                <TableCell align="right">Total Tax Percentage</TableCell>
                <TableCell align="right">Total Tax</TableCell>
                <TableCell align="right">Total</TableCell>
                {/* <TableCell align="right">Action</TableCell> */}
              </TableRow>
            </TableHead>

            <TableBody>
              {vehicleServicePartDetails?.map((row) => (
                <TableRow key={row.id}>
                  <TableCell>{row.partName || "-"}</TableCell>
                  <TableCell>{row.partNumber || "-"}</TableCell>
                  <TableCell>{row.actionOnPart || "-"}</TableCell>
                  <TableCell>{row.quantity || "-"}</TableCell>
                  <TableCell>{row.unitPrice || "-"}</TableCell>                 
                  <TableCell align="right">
                    {ccyFormat(row.laborCost)}
                  </TableCell>
                  <TableCell align="right">
                    {ccyFormat(row.discountAmount)}
                  </TableCell>

                  <TableCell align="right">
                    {ccyFormat(row.discountPercentage)}
                  </TableCell>
                  <TableCell align="right">
                    {ccyFormat(row.cgstPercentage)}
                  </TableCell>
                  <TableCell align="right">
                    {ccyFormat(row.sgstPercentage)}
                  </TableCell>
                  <TableCell align="right">
                    {ccyFormat(row.totalTaxPercentage)}
                  </TableCell>
                  <TableCell align="right">{ccyFormat(row.totalTax)}</TableCell>
                  <TableCell align="right">
                    {ccyFormat(row.totalCost)}
                  </TableCell>
                  {/* <TableCell align="right">
                            <button
                              type="button"
                              title="Save"
                              onClick={() => {
                                setCreationType({ type: "edit", id: row.id });
                                setActiveTab("vehicleservicetasks");
                                setPartService([
                                  {
                                    description: row.taskDescription || "",
                                    panelDetails: row.panelDetails || "",
                                    attachements: JSON.parse(row.attachments) || [],
                                    cost: row.totalCost || "",
                                    laborCost: row.laborCost || "",
                                  },
                                ]);
                              }}
                              className="text-green-500 hover:text-green-700"
                            >
                              <Pencil size={24} />
                            </button>
                          </TableCell> */}
                </TableRow>
              ))}

              {/* <TableRow>
                        <TableCell
                          colSpan={4}
                          align="right"
                          sx={{ fontWeight: "bold" }}
                        >
                          Grand Total
                        </TableCell>
                        <TableCell align="right" sx={{ fontWeight: "bold" }}>
                          {ccyFormat(grandTotalForTasks)}
                        </TableCell>
                      </TableRow> */}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
};

export default Vehicleservicepartdetails;
